// src/store/modules/currency/index.js
// Global currency management module (same pattern as VA Portal)

import { CURRENCY_MAP } from '@/utils/const';
import { getBillingSettingApi } from '@/api/setting';

// Load currency from localStorage
function loadFromStorage() {
  try {
    const currencyStr = localStorage.getItem('currency');
    if (currencyStr) {
      return JSON.parse(currencyStr);
    }
  } catch (e) {
    console.warn('Failed to parse currency from localStorage:', e);
  }
  return { name: 'USD', symbol: '$' };
}

// Save currency to localStorage
function saveToStorage(currency) {
  localStorage.setItem('currency', JSON.stringify(currency));
}

const persisted = loadFromStorage();

export default {
  namespaced: true,

  state: {
    name: persisted.name || 'USD',
    symbol: persisted.symbol || '$',
  },

  getters: {
    currencyName: (state) => state.name,
    currencySymbol: (state) => state.symbol,
  },

  mutations: {
    SET_CURRENCY(state, { name, symbol }) {
      state.name = name;
      state.symbol = symbol;
      saveToStorage({ name, symbol });
    },
  },

  actions: {
    /**
     * Set currency from billing settings API
     * This fetches the practice currency and updates the store + localStorage
     * Should be called when entering eZ-Bill or any page that needs currency
     */
    async setCurrency({ commit }) {
      try {
        const response = await getBillingSettingApi();
        const practiceCurrency = response.data?.practice?.currency;
        const name = practiceCurrency ? practiceCurrency.toUpperCase() : 'USD';
        const symbol = CURRENCY_MAP[name] || '$';
        
        commit('SET_CURRENCY', { name, symbol });
        return { name, symbol };
      } catch (err) {
        console.error('Failed to fetch currency from billing settings:', err);
        // Fall back to default
        const defaultCurrency = { name: 'USD', symbol: '$' };
        commit('SET_CURRENCY', defaultCurrency);
        return defaultCurrency;
      }
    },

    /**
     * Set currency directly (for cases where you already have the currency name)
     */
    setCurrencyDirect({ commit }, currencyName) {
      const name = (currencyName || 'USD').toUpperCase();
      const symbol = CURRENCY_MAP[name] || '$';
      commit('SET_CURRENCY', { name, symbol });
      return { name, symbol };
    },
  },
};
